// extracted by mini-css-extract-plugin
export default {"container":"SubscriptionAdministration_container__OEPQV","button-container":"SubscriptionAdministration_button-container__X9W+d"};